import * as actionTypes from './../actions/types'

export function user(state = {}, action) {
  switch (action.type) {
    case actionTypes.LOGIN_SUCCESS:
      return Object.assign({}, state, {
        jwt: action.jwt,
      })
    case actionTypes.LOGIN_ERROR:
      return Object.assign({}, state, {
        error: action.error,
      })
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/user.js